import React from "react";
import usePatchHook from "../../customHooks/usePatchHook";
import APIS from "../../constant/EndPoint";
import { useParams } from "react-router-dom";
import loadable from "@loadable/component";
import useGetHook from "../../customHooks/useGetHook";
import { tw } from "@careinfo/tailwind";
import CreateIcon from "../../Icons/CreateIcon";
import Spinner from "../../components/Reusable/Spinner";
import usePostHook from "../../customHooks/usePostHook";
const EditDarazOrderComponent = loadable(
  () => import("../../components/DarazOrder/EditDarazOrder")
);

const EditDarazOrder = () => {
  const { id } = useParams();
  const { mutateAsync, isLoading } = usePatchHook({
    queryKey: ["daraz-order", `daraz-order-${id}`],
    navigateURL: "/",
  });

  const { data, isLoading: isDataLoading } = useGetHook({
    queryKey: ["daraz-order", `daraz-order-${id}`],
    url: `${APIS.DARAZ_ORDER}${id}/`,
    params: {},
  });
  const { mutateAsync: toggleAsync, isPostLoading: isMarkasDoneloading } =
    usePostHook({
      queryKey: ["daraz-order", `daraz-order-${id}`],
      navigateURL: "/",
    });

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.DARAZ_ORDER}${id}/`;
    let formData = {
      ...values,
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.error(err);
    }
  };

  const handleMarkAsDone = async (values: any, setError: any) => {
    const url = `${APIS.DARAZ_ORDER}${id}/mark-done/`;
    let formData = {};
    try {
      const res = await toggleAsync({ url, formData, setError });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Edit Daraz Order
        </span>
      </div>
      {isDataLoading ? (
        <Spinner />
      ) : (
        <EditDarazOrderComponent
          handleEdit={handleEdit}
          isLoading={isLoading}
          handleMarkAsDone={handleMarkAsDone}
          isMarkasDoneloading={isMarkasDoneloading}
          data={data}
          id={id}
        />
      )}
    </>
  );
};

export default EditDarazOrder;
